import { render, staticRenderFns } from "./BottomFooter.vue?vue&type=template&id=4eaa0b7d&scoped=true"
import script from "./BottomFooter.vue?vue&type=script&lang=js"
export * from "./BottomFooter.vue?vue&type=script&lang=js"
import style0 from "./BottomFooter.vue?vue&type=style&index=0&id=4eaa0b7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eaa0b7d",
  null
  
)

export default component.exports